import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { creerSensation, lireSensation, majSensation, supprimerSensation } from '../../db/repo'
import { fromDatetimeLocalValue, nowInstant, toDatetimeLocalValue } from '../../domain/time'
import { SENSATION_TYPES, SYMPTOM_LABELS, type SensationType } from '../../domain/types'
import { BoutonSupprimer, Carte, Champ, Curseur, Entete } from '../composants'

export function PageSymptome() {
  const { id } = useParams()
  const navigate = useNavigate()
  const edition = Boolean(id)

  const [type, setType] = useState<SensationType>('ballonnements')
  const [at, setAt] = useState(() => toDatetimeLocalValue(nowInstant()))
  const [intensite, setIntensite] = useState(5)
  const [notes, setNotes] = useState('')

  useEffect(() => {
    if (!id) return
    void lireSensation(id).then((e) => {
      if (!e) return
      setType(e.type)
      setAt(toDatetimeLocalValue(e.at))
      setIntensite(e.intensite)
      setNotes(e.notes ?? '')
    })
  }, [id])

  const enregistrer = async () => {
    const data = {
      type,
      at: fromDatetimeLocalValue(at),
      intensite,
      ...(notes.trim() ? { notes: notes.trim() } : {}),
    }
    if (id) await majSensation(id, data)
    else await creerSensation(data)
    navigate(-1)
  }

  return (
    <>
      <Entete titre={edition ? 'Modifier la sensation' : 'Nouvelle sensation'} retour />

      <main className="contenu">
        <Carte titre="Ressenti">
          <div className="puces">
            {SENSATION_TYPES.map((s) => (
              <button
                key={s}
                type="button"
                className="choix"
                aria-pressed={type === s}
                onClick={() => setType(s)}
              >
                {SYMPTOM_LABELS[s]}
              </button>
            ))}
          </div>
        </Carte>

        <Carte titre="Quand">
          <Champ
            label="Moment"
            aide="Notez l'instant où vous le ressentez : il n'y a rien à clôturer. Si cela persiste, notez-le à nouveau plus tard — l'application regroupe les notes rapprochées en une seule poussée."
          >
            <input type="datetime-local" value={at} onChange={(e) => setAt(e.target.value)} />
          </Champ>
        </Carte>

        <Carte titre="Intensité">
          <Curseur
            label="Intensité ressentie"
            valeur={intensite}
            onChange={setIntensite}
            suffixe="/10"
          />
        </Carte>

        <Carte>
          <Champ label="Notes (facultatif)">
            <textarea value={notes} onChange={(e) => setNotes(e.target.value)} />
          </Champ>
        </Carte>

        <button
          type="button"
          className="btn btn--principal btn--large"
          onClick={() => void enregistrer()}
        >
          Enregistrer
        </button>

        {id && (
          <BoutonSupprimer
            titre="Supprimer cette sensation ?"
            message="Elle sera définitivement retirée du journal et des analyses."
            onSupprimer={() => {
              void supprimerSensation(id).then(() => navigate('/journal'))
            }}
          />
        )}
      </main>
    </>
  )
}
